import {useI18n} from 'store/Store'
import {styled, Tooltip} from '@mui/material'
import {videoIconMap} from 'constants/dances'

const TableFiles = ({dance}) => {
    const {i18n} = useI18n()
    const {videoDance, videoFull, videoTeach} = dance.videos

    const videoDataMap = {
        videoFull: videoFull?.videoUrl,
        videoTeach: videoTeach?.videoUrl,
        videoDance: videoDance?.videoUrl,
        audio: dance?.songs?.[0]?.urlFull,
    }

    return (
        <Container>
            {Object.entries(videoIconMap).map(
                ([key, {Icon, titleKey, size}]) => {
                    const url = videoDataMap[key]
                    if (!url) return null

                    return (
                        <Tooltip key={key} title={i18n.t(titleKey)}>
                            <Icon height={size} color="green" />
                        </Tooltip>
                    )
                }
            )}
        </Container>
    )
}

export default TableFiles

const Container = styled('div')`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
`
